









































































































































































import { Component, Vue } from "vue-property-decorator";
import {
  addPeriodTime,
  updataPeriodTime,
  selectPeriodTime,
  deletePeriodTime,
} from "@/serve/medicalAppointment/plan";
import { Calendar } from "element-ui";
import { Card, Switch, TimePicker, TimeSelect } from "element-ui";
import dayjs from "dayjs";
// 定义表单类型接口
interface FormType {
  title: string;
  startTime: any;
  endTime: any;
  status: boolean;
  sort: string | number;
  description: string;
}
@Component({
  name: "companyManage",
  components: { Calendar, Card, Switch, TimePicker, TimeSelect },
})
export default class MedicalReport extends Vue {
  private rules = {
    title: [
      { required: true, message: "请输入标题", trigger: "blur" },
      { min: 1, max: 16, message: "长度在 1 到 16 个字符", trigger: "blur" },
    ],
  };
  public itemDialog = false;
  public form: FormType = {
    //标题
    title: "",
    // 开始时间
    startTime: null,
    // 结束时间
    endTime: "",
    // 状态
    status: true,
    // 排序
    sort: "",
    // 说明
    description: "",
  };

  public formData = {
    title: "",
    status: "",
  };
  // 新增时间段addNew
  public addNew() {
    this.form = {
      //标题
      title: "",
      // 开始时间
      startTime: new Date(2023, 0, 1, 7, 0),
      // 结束时间
      endTime: new Date(2023, 0, 1, 7, 0),
      // 状态
      status: true,
      // 排序
      sort: "",
      // 说明
      description: "",
    };
    this.itemDialog = true;
  }
  public handleStartTimeChange(val: any) {
    console.log("开始时间", val);
    this.form.endTime = val;
  }
  private submitForm(formName: string) {
    (this.$refs[formName] as any).validate((valid: any) => {
      if (valid) {
        const params = this.form;
        console.log("submit!", params);

        params.startTime = params.startTime
          ? dayjs(params.startTime).format("HH:mm")
          : null;
        params.endTime = params.endTime
          ? dayjs(params.endTime).format("HH:mm")
          : null;
        console.log("submit!", params);
        if ((params as any).id) {
          updataPeriodTime(this.form).then((res: any) => {
            if (res.code === 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              this.itemDialog = false;
              this.formData.title = "";
              this.getReportList();
            }
          });
        } else {
          addPeriodTime(this.form).then((res: any) => {
            if (res.code === 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              this.itemDialog = false;
              this.formData.title = "";
              this.getReportList();
            }
          });
        }
      } else {
        console.log("error submit!!");
        return false;
      }
    });
  }

  //日期选择器
  public value = new Date();
  //是否展示号源编辑框
  public dialogTime = false;
  public tableData = [];
  public created() {
    //获取列表
    this.getReportList();
  }
  // 获取数据接口
  public async getReportList() {
    selectPeriodTime(this.formData).then((res: any) => {
      console.log("表格数据", res);
      this.tableData = res.data;
    });
  }
  // 筛选按钮
  public onSubmit() {
    this.getReportList();
  }

  //reset重置搜索框
  public reset() {
    this.formData.title = "";
    this.getReportList();
  }

  public changeSoure(data: any) {
    console.log("data", data);
    this.itemDialog = true;
    this.form = data;
    this.form.startTime = this.dateFun(data.startTime);
    this.form.endTime = this.dateFun(data.endTime);
  }
  public changeDelete(data: any) {
    console.log("data", data);
    (this as any).$messageBox
      .confirm(`您确定是否删除时间段名称为${data.title}的这一条数据`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
      .then(async () => {
        const res = await deletePeriodTime([data.id]);
        if (res.code === 200) {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.getReportList();
        }
      });
  }
  public dateFun(data: any) {
    const [hours, minutes] = data.split(":").map(Number);

    // 创建日期对象（使用当前日期）
    const date = new Date();

    // 设置时间为10:50
    date.setHours(hours);
    date.setMinutes(minutes);
    date.setSeconds(0);
    date.setMilliseconds(0);

    // 计算UTC时间与本地时间的差值（分钟）
    const offset = date.getTimezoneOffset();

    // 中国标准时间是UTC+8，计算对应的时间戳
    const cstTimestamp = date.getTime() + (offset + 480) * 60 * 1000;

    // 创建中国标准时间对象
    const cstDate = new Date(cstTimestamp);

    // 格式化输出
    return cstDate
      .toLocaleString("zh-CN", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      })
      .replace(/\//g, "-");
  }
}
